import 'ion-rangeslider';

export default () => {
  $(document).ready(function() {
    $("#gl-salary-range, #gl-adv-search-range").ionRangeSlider({
        type: "double",
        min: 50,
        max: 10000,
        step: 50,
        from: 500,
        to: 7000,
        hide_min_max: true,
        // hide_from_to: true,
        grid: false,
    });

    var $result = $(".gl-range-value");
    var track = function (data) {
        $result.html('$' + data.from + ' - ' + '$' + data.to);
    };

    $("#gl-search-range").ionRangeSlider({
        type: "double",
        min: 50,
        max: 10000,
        step: 50,
        from: 500,
        to: 7000,
        hide_min_max: true,
        hide_from_to: true,
        grid: false,
        onStart: track,
        onChange: track,
    });
  });
};


/** WEBPACK FOOTER **
 ** ./assets/src/js/rangeSlider/rangeSliderInit.js
 **/